import React from 'react';
import cx from 'classnames';

import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import ClusterLayout from '../ClusterLayout';

import stylesheet from './Modal.css';

export type ModalFooterProps = {
  /** The footer content inside the modal.  */
  children?: React.ReactNode;
  /** Change the content justification for the footer. To ensure design consistency, Only a subset (flex-end and `space-between`)
   * of normal justification choices are available.
   */
  justifyContent?: 'flex-end' | 'space-between';
  /** Additional class names to apply to the footer. */
  className?: string;
  note?: string;
};

const ModalFooter = ({
  children,
  className,
  justifyContent = 'flex-end',
  note,
  ...rest
}: ModalFooterProps) => {
  const isRedesigned = mcdsFlagCheck(
    'xp_mcds_redesign_components_organisms_part_2',
  );

  return (
    <div
      className={cx(
        stylesheet.footer,
        { [stylesheet.footerWithNote]: note },
        className,
      )}
      {...rest}
    >
      {isRedesigned ? (
        <>
          {note && <span className={stylesheet.footerNote}>{note}</span>}
          <div className={stylesheet.footerContent}>{children}</div>
        </>
      ) : (
        <ClusterLayout justifyContent={justifyContent}>
          {children}
        </ClusterLayout>
      )}
    </div>
  );
};

export default ModalFooter;
